import _ from 'lodash'

import * as define from '@/define'
import math from '@/utils/math'
import store from '@/store'

/** 数量項目定義 */
const QTY = {
  current: 'current',               // 現在数量
  ordered: 'ordered',               // 初回注文数量
  unallocated: 'unallocated',       // 未引当数
  pending: 'pending',               // 処理待ち数
  preExport: 'preExport',           // 指図待ち数
  preReExport: 'preReExport',       // 再送指図待ち数
  canceled: 'canceled',             // 指図前キャンセル数
  exported: 'exported',             // 指図数
  shipped: 'shipped',               // 出荷完了数
  unshipped: 'unshipped',           // 出荷キャンセル数
  inshipCanceled: 'inshipCanceled', // 出荷前キャンセル数
  transfer: 'transfer',             // 振替数
  receiveShipped: 'receiveShipped', // 返品数
  receiveFixed: 'receiveFixed',     // 処理済み返品数
  exOut: 'exOut',                   // 交換出荷数(指図待ち)
  exOutExported: 'exOutExported',   // 交換出荷数(指図済み)
  exOutShipped: 'exOutShipped',     // 交換出荷数(実績)
  exOutUnshipped: 'exOutUnshipped', // 交換出荷キャンセル数
  exOutFixed: 'exOutFixed',         // 処理済交換出荷数
  exIn: 'exIn',                     // 交換返品数
  exInShipped: 'exInShipped',       // 交換返品数(実績)
  exInFixed: 'exInFixed'            // 処理済交換返品数
}

/** 注文ステータス */
const ORDER_STATUS = {
  UNALLOCATED: { label: '未引当', class: 'tag-orange-light-1', sortIx: 1 },
  PENDING: { label: '処理待ち', class: 'tag-orange', sortIx: 2 },
  PRE_EXPORT: { label: '指図待ち', class: 'tag-green-light-1', sortIx: 3 },
  PRE_RE_EXPORT: { label: '再送指図待ち', class: 'tag-green-light-2', sortIx: 4 },
  EXPORT: { label: '出荷準備中', class: 'tag-green', sortIx: 5 },
  PARTIAL_SHIPPED: { label: '一部出荷', class: 'tag-green-dark-1', sortIx: 6 },
  SHIPPED: { label: '出荷完了', class: 'tag-blue', sortIx: 7 },
  UNSHIPPED: { label: '出荷キャンセル', class: 'tag-pink', sortIx: 8 },
  PARTIAL_CANCELED: { label: '一部キャンセル', class: 'tag-grey', sortIx: 9 },
  CANCELED: { label: 'キャンセル', class: 'tag-grey-dark-2', sortIx: 10 },
  RECEIVED_SHIPPED: { label: '未処理返品', class: 'tag-red', sortIx: 11 },
  RECEIVED: { label: '返品完了', class: 'tag-pink-light-1', sortIx: 12 },
  EX_OUT: { label: '交換出荷指図待ち', class: 'tag-purple-light-1', sortIx: 13 },
  EX_EXPORT: { label: '交換出荷準備中', class: 'tag-purple-light-2', sortIx: 14 },
  EX_IN: { label: '交換返品待ち', class: 'tag-purple', sortIx: 15 },
  UN_REG_EX_OUT: { label: '交換出荷未登録', class: 'tag-pink-dark-1', sortIx: 16 },
  EX_FIXED: { label: '交換出荷完了', class: 'tag-blue-dark-1', sortIx: 17 },
  EX_SHIPPED: { label: '交換出荷済み', class: 'tag-green-dark-2', sortIx: 18 },
  EX_UNSHIPPED: { label: '交換出荷キャンセル', class: 'tag-red-dark-1', sortIx: 19 },
  NS_UNPROCESSED: { label: '未完了(非出荷)', class: 'tag-orange-light-1', sortIx: 20 },
  NS_PARTIAL_PROCESSED: { label: '一部完了(非出荷)', class: 'tag-green-dark-1', sortIx: 21 },
  NS_PROCESSED: { label: '完了(非出荷)', class: 'tag-blue', sortIx: 22 },
  NS_FAILED: { label: '不可(非出荷)', class: 'tag-pink', sortIx: 23 },
  NS_PARTIAL_CANCELED: { label: '一部取消(非出荷)', class: 'tag-grey', sortIx: 24 },
  NS_CANCELED: { label: '取消(非出荷)', class: 'tag-grey-dark-2', sortIx: 25 },
  NS_RECEIVED: { label: '返品(非出荷)', class: 'tag-pink-light-1', sortIx: 26 }
}

/** 共存不可ステータスリスト */
const ORDER_STATUS_CONFLICT_LIST = [
  { status: ORDER_STATUS.SHIPPED,
    conflict: [ ORDER_STATUS.UNALLOCATED, ORDER_STATUS.PENDING, ORDER_STATUS.PRE_EXPORT,
      ORDER_STATUS.PRE_RE_EXPORT, ORDER_STATUS.EXPORT, ORDER_STATUS.UNSHIPPED ],
    add: ORDER_STATUS.PARTIAL_SHIPPED
  },
  { status: ORDER_STATUS.CANCELED,
    conflict: [ ORDER_STATUS.UNALLOCATED, ORDER_STATUS.PENDING, ORDER_STATUS.PRE_EXPORT,
      ORDER_STATUS.PRE_RE_EXPORT, ORDER_STATUS.EXPORT, ORDER_STATUS.UNSHIPPED,
      ORDER_STATUS.SHIPPED ],
    add: ORDER_STATUS.PARTIAL_CANCELED
  },
  { status: ORDER_STATUS.RECEIVED,
    conflict: [ ORDER_STATUS.RECEIVED_SHIPPED ]
  },
  { status: ORDER_STATUS.EX_FIXED,
    conflict: [ ORDER_STATUS.EX_EXPORT, ORDER_STATUS.EX_OUT, ORDER_STATUS.EX_IN,
      ORDER_STATUS.UN_REG_EX_OUT, ORDER_STATUS.EX_SHIPPED, ORDER_STATUS.EX_UNSHIPPED ]
  },
  { status: ORDER_STATUS.NS_PROCESSED,
    conflict: [ ORDER_STATUS.NS_FAILED, ORDER_STATUS.NS_PARTIAL_CANCELED, ORDER_STATUS.NS_CANCELED ],
    add: ORDER_STATUS.NS_PARTIAL_PROCESSED
  },
  { status: ORDER_STATUS.NS_CANCELED,
    conflict: [ ORDER_STATUS.NS_UNPROCESSED, ORDER_STATUS.NS_FAILED,
      ORDER_STATUS.NS_PARTIAL_PROCESSED, ORDER_STATUS.NS_PROCESSED ],
    add: ORDER_STATUS.NS_PARTIAL_CANCELED
  }
]

/**
 * qtyからkeyの値を取得する
 * @param {*} qty 数量情報
 * @param {*} key キー
 * @returns {Number} 数量. 一致するkeyが存在しない場合は0を返却する
 */
const getQty = (qty, key) => {
  return Number(_.get(qty, key, 0))
}

/**
 * 未出荷完了かチェックする
 * @param {*} qty 数量情報
 */
const isIncompleteOrder = (qty) => {
  return getQty(qty, QTY.unallocated) > 0 ||
    getQty(qty, QTY.pending) > 0 ||
    getQty(qty, QTY.preExport) > 0 ||
    getQty(qty, QTY.preReExport) > 0 ||
    getQty(qty, QTY.exported) > 0 ||
    getQty(qty, QTY.unshipped) > 0
}

/**
 * 未引当かチェックする
 * @param {*} qty 数量情報
 */
const isUnallocated = (qty) => {
  return getQty(qty, QTY.unallocated) > 0
}

/**
 * 処理待ちかチェックする
 * @param {*} qty 数量情報
 */
const isPending = (qty) => {
  return getQty(qty, QTY.pending) > 0
}

/**
 * 指図待ちかチェックする
 * @param {*} qty 数量情報
 */
const isPreExport = (qty) => {
  return getQty(qty, QTY.preExport) > 0
}

/**
 * 再送指図待ちかチェックする
 * @param {*} qty 数量情報
 */
const isPreReExport = (qty) => {
  return getQty(qty, QTY.preReExport) > 0
}

/**
 * 出荷準備中かチェックする
 * @param {*} qty 数量情報
 */
const isExported = (qty) => {
  return getQty(qty, QTY.exported) > 0
}

/**
 * 一部出荷完了かチェックする
 * @param {*} qty 数量情報
 */
const isPartialShipped = (qty) => {
  return getQty(qty, QTY.shipped) > 0 && isIncompleteOrder(qty)
}

/**
 * 出荷完了かチェックする
 * @param {*} qty 数量情報
 */
const isShipped = (qty) => {
  return getQty(qty, QTY.shipped) > 0 && !isIncompleteOrder(qty)
}

/**
 * 出荷キャンセルかチェックする
 * @param {*} qty 数量情報
 */
const isUnshipped = (qty) => {
  return getQty(qty, QTY.unshipped) > 0
}

/**
 * 一部キャンセルかチェックする
 * @param {*} qty 数量情報
 */
const isPartialCanceled = (qty) => {
  return (getQty(qty, QTY.canceled) > 0 || getQty(qty, QTY.inshipCanceled) > 0) &&
    (getQty(qty, QTY.shipped) > 0 || isIncompleteOrder(qty))
}

/**
 * キャンセルかチェックする
 * @param {*} qty 数量情報
 */
const isCanceled = (qty) => {
  return (getQty(qty, QTY.canceled) > 0 || getQty(qty, QTY.inshipCanceled) > 0) &&
    getQty(qty, QTY.shipped) === 0 &&
    !isIncompleteOrder(qty)
}

/**
 * 未処理返品かチェックする
 * @param {*} qty 数量情報
 */
const isReceiveShipped = (qty) => {
  return getQty(qty, QTY.receiveShipped) > 0
}

/**
 * 返品完了かチェックする
 * @param {*} qty 数量情報
 */
const isReceiveFixed = (qty) => {
  return getQty(qty, QTY.receiveShipped) === 0 && getQty(qty, QTY.receiveFixed) > 0
}

/**
 * 交換出荷指図待ちかチェックする
 * @param {*} qty 数量情報
 */
const isExOut = (qty) => {
  return getQty(qty, QTY.exOut) > 0
}

/**
 * 交換出荷準備中かチェックする
 * @param {*} qty 数量情報
 */
const isExPrepareShipment = (qty) => {
  return math.subtract([getQty(qty, QTY.exOutExported), getQty(qty, QTY.exOutShipped), getQty(qty, QTY.exOutUnshipped)]) > 0
}

/**
 * 交換返品待ちかチェックする
 * @param {*} qty 数量情報
 */
const isWaitingExIn = (qty) => {
  return math.subtract([getQty(qty, QTY.exIn), getQty(qty, QTY.exInShipped)]) > 0
}

/**
 * 交換出荷未登録かチェックする
 * @param {*} qty 数量情報
 */
const isUnregisteredExOut = (qty) => {
  return math.subtract([getQty(qty, QTY.exInShipped), getQty(qty, QTY.exIn)]) > 0
}

/**
 * 交換出荷完了かチェックする
 * @param {*} qty 数量情報
 */
const isCompletedExOut = (qty) => {
  return getQty(qty, QTY.exOutFixed) > 0 && (getQty(qty, QTY.exOut) === 0 && getQty(qty, QTY.exOutExported) === 0)
}

/**
 * 交換出荷済みかチェックする
 * @param {*} qty 数量情報
 */
const isExOutShipped = (qty) => {
  return getQty(qty, QTY.exOutShipped) > 0
}

/**
 * 交換出荷キャンセルかチェックする
 * @param {*} qty 数量情報
 */
const isExOutUnshipped = (qty) => {
  return getQty(qty, QTY.exOutUnshipped) > 0
}

// /**
//  * 未完了(非出荷) かチェックする
//  * @param {*} qty 数量情報
//  * @returns {Boolean} 結果
//  */
// const isUnprocessedNoShipment = (qty) => {
//   return getQty(qty, QTY.shipped) === 0 &&
//     (getQty(qty, QTY.unallocated) > 0 ||
//     getQty(qty, QTY.pending) > 0 ||
//     getQty(qty, QTY.preExport) > 0 ||
//     getQty(qty, QTY.preReExport) > 0 ||
//     getQty(qty, QTY.exported) > 0 > 0)
// }
// /**
//  * 一部完了(非出荷) かチェックする
//  * @param {*} qty 数量情報
//  * @returns {Boolean} 結果
//  */
// const isPartialProcessedNoShipment = (qty) => {
//   return getQty(qty, QTY.shipped) > 0 && isIncompleteOrder(qty)
// }
// /**
//  * 完了(非出荷) かチェックする
//  * @param {*} qty 数量情報
//  * @returns {Boolean} 結果
//  */
// const isProcessedNoShipment = (qty) => {
//   return getQty(qty, QTY.shipped) > 0 && !isIncompleteOrder(qty)
// }
// /**
//  * 不可(非出荷) かチェックする
//  * @param {*} qty 数量情報
//  * @returns {Boolean} 結果
//  */
// const isFailedProcessedNoShipment = (qty) => {
//   return getQty(qty, QTY.unshipped) > 0
// }
// /**
//  * 一部キャンセル(非出荷) かチェックする
//  * @param {*} qty 数量情報
//  * @returns {Boolean} 結果
//  */
// const isPartialCanceledNoShipment = (qty) => {
//   return (getQty(qty, QTY.canceled) > 0 || getQty(qty, QTY.inshipCanceled) > 0) &&
//     (getQty(qty, QTY.shipped) > 0 || isIncompleteOrder(qty))
// }
// /**
//  * キャンセル(非出荷) かチェックする
//  * @param {*} qty 数量情報
//  * @returns {Boolean} 結果
//  */
// const isCanceledNoShipment = (qty) => {
//   return (getQty(qty, QTY.canceled) > 0 || getQty(qty, QTY.inshipCanceled) > 0) &&
//     getQty(qty, QTY.shipped) === 0 && !isIncompleteOrder(qty)
// }
// /**
//  * 返品(非出荷) かチェックする
//  * @param {*} qty 数量情報
//  * @returns {Boolean} 結果
//  */
// const isReceivedNoShipment = (qty) => {
//   return getQty(qty, QTY.receiveFixed) > 0
// }

/**
 * 衝突するステータスが存在する場合、ステータスから対象ステータスを削除し、在るべきステータスを追加する
 * @param {*} statuses ステータス
 * @param {*} checkStatus 対象ステータス(削除対象)
 * @param {*} conflictStatuses 衝突ステータス
 * @param {*} addStatus 衝突時の追加ステータス
 */
const rejectConflictOrderStatus = (statuses, checkStatus, conflictStatuses, addStatus) => {

  if ((statuses || '') === '') return

  // ステータスのラベルを配列に展開
  const labels = statuses.map(v => v.label)
  // 対象ステータスのインデックスを取得
  const ix = labels.indexOf(checkStatus.label)

  if (ix !== -1) {
    for (const cStatus of conflictStatuses) {
      // 衝突ステータスが存在する場合
      if (labels.includes(cStatus.label)) {

        // ステータスから対象ステータスを削除
        statuses.splice(ix, 1)

        // 追加ステータスが未登録の場合
        if ((addStatus || '') !== '' && !labels.includes(addStatus.label)) {
          // 衝突時のステータスを追加
          statuses.push(addStatus)
        }

        break
      }
    }
  }

}

export default {
  computed: {
  },
  methods: {
    $_orderUtil_current: (qty) => getQty(qty, 'current'),
    $_orderUtil_ordered: (qty) => getQty(qty, 'ordered'),
    $_orderUtil_unallocated: (qty) => getQty(qty, 'unallocated'),
    $_orderUtil_pending: (qty) => getQty(qty, 'pending'),
    $_orderUtil_preExport: (qty) => getQty(qty, 'preExport'),
    $_orderUtil_preReExport: (qty) => getQty(qty, 'preReExport'),
    $_orderUtil_canceled: (qty) => getQty(qty, 'canceled'),
    $_orderUtil_exported: (qty) => getQty(qty, 'exported'),
    $_orderUtil_shipped: (qty) => getQty(qty, 'shipped'),
    $_orderUtil_unshipped: (qty) => getQty(qty, 'unshipped'),
    $_orderUtil_inshipCanceled: (qty) => getQty(qty, 'inshipCanceled'),
    $_orderUtil_transfer: (qty) => getQty(qty, 'transfer'),
    $_orderUtil_receiveShipped: (qty) => getQty(qty, 'receiveShipped'),
    $_orderUtil_receiveFixed: (qty) => getQty(qty, 'receiveFixed'),
    $_orderUtil_exOut: (qty) => getQty(qty, 'exOut'),
    $_orderUtil_exOutExported: (qty) => getQty(qty, 'exOutExported'),
    $_orderUtil_exOutShipped: (qty) => getQty(qty, 'exOutShipped'),
    $_orderUtil_exOutUnshipped: (qty) => getQty(qty, 'exOutUnshipped'),
    $_orderUtil_exOutFixed: (qty) => getQty(qty, 'exOutFixed'),
    $_orderUtil_exIn: (qty) => getQty(qty, 'exIn'),
    $_orderUtil_exInShipped: (qty) => getQty(qty, 'exInShipped'),
    $_orderUtil_exInFixed: (qty) => getQty(qty, 'exInFixed'),
    // 交換出荷可能数
    $_orderUtil_exchangeableQty (qty) {
      return math.add([
        this.$_orderUtil_shipped(qty),
        -this.$_orderUtil_receiveFixed(qty),
        -this.$_orderUtil_exIn(qty),
        -this.$_orderUtil_exInFixed(qty),
        this.$_orderUtil_exOutFixed(qty)])
    },
    // 未処理返品数
    $_orderUtil_unprocessedReceivedQty (qty) {
      return this.$_orderUtil_receiveShipped(qty)
    },
    // 指図登録可能数
    $_orderUtil_exportableQty (qty) {
      return math.subtract([this.$_orderUtil_current(qty), this.$_orderUtil_unallocated(qty), this.$_orderUtil_unshipped(qty)])
    },

    // 注文修正の可否
    $_orderUtil_isEditableByQty (items) {
      return true
    },
    // 再送の可否
    $_orderUtil_isShortageShippableByQty (items) {
      return _.chain(items)
        .map(val => val.qty)
        .find(val => {
          return this.$_orderUtil_unshipped(val) > 0 ||
            this.$_orderUtil_preReExport(val) > 0
        })
        .value() != null
    },
    // 交換出荷の可否
    $_orderUtil_isExchangeableByQty (items) {
      return _.chain(items)
        .map(val => val.qty)
        .find(val => {
          if (val.isBundle) {
            // バンドルヘッダーの場合、構成品をチェック
            return _.chain(val.bundleItems)
              .find(bVal => {
                return this.$_orderUtil_exchangeableQty(bVal) > 0 ||
                  this.$_orderUtil_exOut(bVal) > 0 ||
                  this.$_orderUtil_exOutUnshipped(bVal) > 0
              })
              .value() != null
          } else {
            return this.$_orderUtil_exchangeableQty(val) > 0 ||
              this.$_orderUtil_exOut(val) > 0 ||
              this.$_orderUtil_exOutUnshipped(val) > 0
          }
        })
        .value() != null
    },

    /**
     * 返品登録の可否をチェックする
     * @param {*} items 注文明細
     * @returns {Boolean} 返品登録の可否
     */
    $_orderUtil_isReceivedFixableByQty (items) {
      // 強制返品設定の取得
      const forceReceive = store.getters['getServiceSiteConfig'](null, 'order_detail', 'receive_config', 'force_receive').v[0]

      /** 出荷商品の場合、登録可否の結果を取得 */
      const isShipmentReceivedFixable = (val) => {
        // [返品] > 0 or [処理済返品] > 0 の明細がある事
        if (this.$_orderUtil_receiveShipped(val.qty) > 0 || this.$_orderUtil_receiveFixed(val.qty) > 0) {
          return true
        }
        // 強制返品設定：1,2 のとき
        if (forceReceive === '1' || forceReceive === '2') {
          // 出荷商品の場合、出荷完了 - 処理済み返品 が 0 以上の明細がある事
          if (math.subtract([this.$_orderUtil_shipped(val.qty), this.$_orderUtil_receiveShipped(val.qty)]) > 0) {
            return true
          }
        }
      }

      /** 非出荷商品の場合、登録可否の結果を取得 */
      const isUnShipmentReceivedFixable = (val) => {
        // [返品] > 0 or [処理済返品] > 0 の明細がある事
        if (this.$_orderUtil_receiveShipped(val.qty) > 0 || this.$_orderUtil_receiveFixed(val.qty) > 0) {
          return true
        }
        // 強制返品設定：1,3 のとき
        if (forceReceive === '1' || forceReceive === '3') {
          // 非出荷商品の場合、出荷完了 - 処理済み返品 が 0 以上の明細がある事
          if (math.subtract([this.$_orderUtil_shipped(val.qty), this.$_orderUtil_receiveShipped(val.qty)]) > 0) {
            return true
          }
        }
      }

      return _.chain(items)
        .find(val => {
          // 出荷品の判断
          if (val.isShipment) {
            // バンドル対象の判断
            if (val.isBundle) {
              // バンドルの場合
              return _.chain(val.bundleItems)
                .find(bVal => {
                  // 出荷品の判断
                  if (bVal.isShipment) {
                    // 出荷商品の場合、登録可否の結果を取得
                    return isShipmentReceivedFixable(val)
                  } else {
                    // 非出荷商品の場合、登録可否の結果を取得
                    return isUnShipmentReceivedFixable(bVal)
                  }
                })
                .value() != null
            } else {
              // バンドル以外の場合
              // 出荷商品の場合、登録可否の結果を取得
              return isShipmentReceivedFixable(val)
            }
          } else {
            // 非出荷商品の場合、登録可否の結果を取得
            return isUnShipmentReceivedFixable(val)
          }
        })
        .value() != null
    },

    // 一括取消の可否
    $_orderUtil_isCancellableByQty (items) {

      const current = _.chain(items)
        .map(val => val.qty)
        .find(val => this.$_orderUtil_current(val) > 0)
        .value()
      // 数量が 0 以上の明細がない場合
      if (current == null) {
        return false
      }

      /** 明細のキャンセル可否 */
      const isCancellable = (val) => {
        if (val.isShipment) {
        // 出荷商品の場合、指図数、出荷数が 0 である事
          return this.$_orderUtil_exported(val.qty) === 0 && this.$_orderUtil_shipped(val.qty) === 0
        } else {
        // 非出荷商品の場合、指図数、出荷数が 0 である、又は数量が 0 である事
          return (this.$_orderUtil_exported(val.qty) === 0 && this.$_orderUtil_shipped(val.qty) === 0) || this.$_orderUtil_current(val.qty) === 0
        }
      }

      const result = !items.some(val => {
        if ((val.bundleItems || []).length === 0) {
        // バンドル構成品を持たない場合
          return !isCancellable(val)
        } else {
        // バンドル構成品を持つ場合
          return val.bundleItems.some((bVal) => {
            return !isCancellable(bVal)
          })
        }
      })

      return result

    },

    // 一括出荷取消の可否
    $_orderUtil_isShipmentCancellableByQty (items) {

      return _.chain(items)
        .map(val => val.qty)
        .find(val => {
          return this.$_orderUtil_exported(val) > 0 ||
            this.$_orderUtil_exOutExported(val) -
            this.$_orderUtil_exOutShipped(val) -
            this.$_orderUtil_exOutUnshipped(val) > 0
        })
        .value() != null
    },

    /**
     * 手動決済可否（注文）
     *  - 可条件
     *   未処理の予約支払処理が存在しない
     *   未完了、金額 0 以上、処理対象、CCS決済 の注文支払が存在する場合
     * @param {*} payments 注文支払
     * @param {*} paymentSets 支払処理
     */
    $_orderUtil_isCapturable (payments, paymentSets) {
      const reservedPaymentSets = _.find(paymentSets, payment =>
        payment.statusCode === define.PAYMENT_SET_STATUS.UNPROCESSED && payment.isReserved === 1)
      return reservedPaymentSets == null &&
        _.find(payments, val => this.$_orderUtil_isCapturable_paymentRow(val)) !== null
    },

    /**
     * 手動決済可否（注文支払行）
     *  - 可条件
     *   未完了、金額 0 以上、処理対象、CCS決済 の注文支払が存在する場合
     * @param {*} row 注文支払行
     */
    $_orderUtil_isCapturable_paymentRow (row) {
      return row.isPaid === 0 &&
          row.amount > 0 && row.isProcessed === 1 &&
          ([ define.PAYMENT_METHOD_TYPE.CCS,
            define.PAYMENT_METHOD_TYPE.CCS_NO_REFUND,
            define.PAYMENT_METHOD_TYPE.CCS_NO_REFUND_NO_COMP ].includes(row.paymentMethod.methodType))
    },

    /**
     * 注文ステータス(ヘッダー)を返却する
     * @param {*} row 注文情報
     * @returns {Array} 注文ステータス
     *  - [ {label: TagName, type: TagType} ]
     */
    $_orderUtil_headerOrderStatusTag (row) {

      /** 明細毎にステータスを取得 */
      let itemStatuses = []
      for (const shipment of row.shipments) {
        // 注文明細
        for (const item of shipment.items) {
          const tags = this.$_orderUtil_orderStatusTag(item)
          itemStatuses = itemStatuses.concat(tags)
          // バンドル構成品
          for (const bItem of item.bundleItems || []) {
            const tags = this.$_orderUtil_orderStatusTag(bItem)
            itemStatuses = itemStatuses.concat(tags)
          }
        }
      }

      /** ステータスの重複の削除 */
      const labels = []
      let orderStatuses = itemStatuses.filter(itemTag => {
        if (labels.indexOf(itemTag.label) === -1) {
          labels.push(itemTag.label)
          return itemTag
        }
      })

      /** 共存できないステータスを削除 */
      for (const s of ORDER_STATUS_CONFLICT_LIST) {
        rejectConflictOrderStatus(orderStatuses, s.status, s.conflict, s.add)
      }

      /** ソート */
      orderStatuses = orderStatuses.sort((a, b) => {
        if (a.sortIx > b.sortIx) return 1
        else if (a.sortIx < b.sortIx) return -1
        else return 0
      })

      return orderStatuses

    },

    /**
     * 注文ステータス(明細)を返却する
     * @param {*} row 注文情報
     * @returns {Array} 注文ステータス
     *  - [ {label: TagName, type: TagType} ]
     */
    $_orderUtil_itemOrderStatusTag (row) {

      /** 明細毎にステータスを取得 */
      let itemStatuses = []

      // 注文明細
      const tags = this.$_orderUtil_orderStatusTag(row)
      itemStatuses = itemStatuses.concat(tags)

      // バンドルフラグが 1 の場合
      if (row.isBundle === 1) {
        for (const bItem of row.bundleItems) {
          // バンドル明細
          const tags = this.$_orderUtil_orderStatusTag(bItem)
          itemStatuses = itemStatuses.concat(tags)
        }
      }

      /** ステータスの重複の削除 */
      const labels = []
      let orderStatuses = itemStatuses.filter(itemTag => {
        if (labels.indexOf(itemTag.label) === -1) {
          labels.push(itemTag.label)
          return itemTag
        }
      })

      /** 共存できないステータスを削除 */
      for (const s of ORDER_STATUS_CONFLICT_LIST) {
        rejectConflictOrderStatus(orderStatuses, s.status, s.conflict, s.add)
      }

      /** ソート */
      orderStatuses = orderStatuses.sort((a, b) => {
        if (a.sortIx > b.sortIx) return 1
        else if (a.sortIx < b.sortIx) return -1
        else return 0
      })

      return orderStatuses

    },

    /**
     * 指定された明細のステータスを返却する
     * @param {Object} row 注文明細情報
     * @returns {Array} 注文明細ステータス
     *  - [ {label: TagName, type: TagType} ]
     */
    $_orderUtil_orderStatusTag (row) {

      const qty = row.qty // 数量情報
      let orderStatuses = []

      // 出荷商品の場合
      if (isUnallocated(qty)) orderStatuses.push(ORDER_STATUS.UNALLOCATED)
      if (isPending(qty)) orderStatuses.push(ORDER_STATUS.PENDING)
      if (isPreExport(qty)) orderStatuses.push(ORDER_STATUS.PRE_EXPORT)
      if (isPreReExport(qty)) orderStatuses.push(ORDER_STATUS.PRE_RE_EXPORT)
      if (isExported(qty)) orderStatuses.push(ORDER_STATUS.EXPORT)
      if (isPartialShipped(qty)) orderStatuses.push(ORDER_STATUS.PARTIAL_SHIPPED)
      if (isShipped(qty)) orderStatuses.push(ORDER_STATUS.SHIPPED)
      if (isUnshipped(qty)) orderStatuses.push(ORDER_STATUS.UNSHIPPED)
      if (isPartialCanceled(qty)) orderStatuses.push(ORDER_STATUS.PARTIAL_CANCELED)
      if (isCanceled(qty)) orderStatuses.push(ORDER_STATUS.CANCELED)
      if (isReceiveShipped(qty)) orderStatuses.push(ORDER_STATUS.RECEIVED_SHIPPED)
      if (isReceiveFixed(qty)) orderStatuses.push(ORDER_STATUS.RECEIVED)
      if (isExOut(qty)) orderStatuses.push(ORDER_STATUS.EX_OUT)
      if (isExPrepareShipment(qty)) orderStatuses.push(ORDER_STATUS.EX_EXPORT)
      if (isWaitingExIn(qty)) orderStatuses.push(ORDER_STATUS.EX_IN)
      if (isUnregisteredExOut(qty)) orderStatuses.push(ORDER_STATUS.UN_REG_EX_OUT)
      if (isCompletedExOut(qty)) orderStatuses.push(ORDER_STATUS.EX_FIXED)
      if (isExOutShipped(qty)) orderStatuses.push(ORDER_STATUS.EX_SHIPPED)
      if (isExOutUnshipped(qty)) orderStatuses.push(ORDER_STATUS.EX_UNSHIPPED)

      // if (row.isShipment) {
      //   // 出荷商品の場合
      //   if (isUnallocated(qty)) orderStatuses.push(ORDER_STATUS.UNALLOCATED)
      //   if (isPending(qty)) orderStatuses.push(ORDER_STATUS.PENDING)
      //   if (isPreExport(qty)) orderStatuses.push(ORDER_STATUS.PRE_EXPORT)
      //   if (isPreReExport(qty)) orderStatuses.push(ORDER_STATUS.PRE_RE_EXPORT)
      //   if (isExported(qty)) orderStatuses.push(ORDER_STATUS.EXPORT)
      //   if (isPartialShipped(qty)) orderStatuses.push(ORDER_STATUS.PARTIAL_SHIPPED)
      //   if (isShipped(qty)) orderStatuses.push(ORDER_STATUS.SHIPPED)
      //   if (isUnshipped(qty)) orderStatuses.push(ORDER_STATUS.UNSHIPPED)
      //   if (isPartialCanceled(qty)) orderStatuses.push(ORDER_STATUS.PARTIAL_CANCELED)
      //   if (isCanceled(qty)) orderStatuses.push(ORDER_STATUS.CANCELED)
      //   if (isReceiveShipped(qty)) orderStatuses.push(ORDER_STATUS.RECEIVED_SHIPPED)
      //   if (isReceiveFixed(qty)) orderStatuses.push(ORDER_STATUS.RECEIVED)
      //   if (isExOut(qty)) orderStatuses.push(ORDER_STATUS.EX_OUT)
      //   if (isExPrepareShipment(qty)) orderStatuses.push(ORDER_STATUS.EX_EXPORT)
      //   if (isWaitingExIn(qty)) orderStatuses.push(ORDER_STATUS.EX_IN)
      //   if (isUnregisteredExOut(qty)) orderStatuses.push(ORDER_STATUS.UN_REG_EX_OUT)
      //   if (isCompletedExOut(qty)) orderStatuses.push(ORDER_STATUS.EX_FIXED)
      //   if (isExOutShipped(qty)) orderStatuses.push(ORDER_STATUS.EX_SHIPPED)
      //   if (isExOutUnshipped(qty)) orderStatuses.push(ORDER_STATUS.EX_UNSHIPPED)
      // } else {
      //   // 非出荷商品の場合
      //   if (isUnprocessedNoShipment(qty)) orderStatuses.push(ORDER_STATUS.NS_UNPROCESSED)
      //   if (isPartialProcessedNoShipment(qty)) orderStatuses.push(ORDER_STATUS.NS_PARTIAL_PROCESSED)
      //   if (isProcessedNoShipment(qty)) orderStatuses.push(ORDER_STATUS.NS_PROCESSED)
      //   if (isFailedProcessedNoShipment(qty)) orderStatuses.push(ORDER_STATUS.NS_FAILED)
      //   if (isPartialCanceledNoShipment(qty)) orderStatuses.push(ORDER_STATUS.NS_PARTIAL_CANCELED)
      //   if (isCanceledNoShipment(qty)) orderStatuses.push(ORDER_STATUS.NS_CANCELED)
      //   if (isReceivedNoShipment(qty)) orderStatuses.push(ORDER_STATUS.NS_RECEIVED)
      // }

      return orderStatuses

    },

    /**
     * 支払方法 tag 用配列にして返却します。
     * @param {Object} payments 支払情報
     * @return {Array} [{label: TagName, type: TagType}]
     */
    $_orderUtil_orderPaymentTag (payments) {
      let orderPaymentTag = []
      for (const payment of payments) {
        if (+payment.amount === 0 && payment.paymentMethod.methodType === define.PAYMENT_METHOD_TYPE.HOLD) {
          continue
        } else {
          orderPaymentTag.push({ label: payment.paymentMethod.nameAbbr, type: 'info' })
        }
      }
      return orderPaymentTag
    },
    /**
     * 作成中指図がある場合、警告ダイアログを表示する
     * @returns {Boolean} ダイアログを表示した場合、true
     */
    $_orderUtil_showOrderExportInProcessDialogIfNeed (order) {
      const inProcess = _.chain(order)
        .get('exports')
        .find(val => val.isAvailable === 1 && val.closedAt != null && val.exportedAt == null)
        .value()
      if (inProcess == null) {
        return false
      }
      this.$alert(
        '指図データ作成中のため、注文の編集は行えません。',
        define.MESSAGE_TITLE,
        { type: 'warning', showClose: false }
      )
      return true
    },
    /**
     * 編集不可支払処理がある場合、警告ダイアログを表示する
     * @returns {Boolean} ダイアログを表示した場合、true
     */
    $_orderUtil_showUneditableOrderPaymentDialogIfNeed (order) {
      const uneditable = _.chain(order)
        .get('payments')
        .find(val => val.editableType !== 1)
        .value()
      if (uneditable == null) {
        return false
      }
      let message = ''
      switch (uneditable.editableType) {
        case 11:  // 支払処理バッチで処理中
          message = '支払処理バッチ中のため、注文の編集は行えません。'
          break
        case 12:  // 与信延長処理中
          message = '与信延長中のため、注文の編集は行えません。'
          break
        case 13:  // 支払処理結果（決済）の確認待ち
        case 14:  // 支払処理結果（返金）の確認待ち
          message = '支払処理結果確認待ちのため、注文の編集は行えません。'
          break
        case 21:  // 手動決済予約中
          message = `手動決済で予約された支払処理があります。
                    注文の編集を行う場合は事前に支払処理結果一覧から手動決済予約を取り消して下さい。`
          break
        case 99:  // エラー終了
          message =
            `支払処理がエラー終了しているため、注文の編集は行えません。
            先に支払処理のエラーを解除してください。`
          break
        default:
          message =
            `注文支払が異常な状態のため、注文の編集は行えません。
            管理者に連絡して下さい。`
          break
      }
      this.$alert(message, define.MESSAGE_TITLE, { type: 'warning', showClose: false })
      return true
    },
    /**
     * 数量計算
     * @param {*} qty 数量情報
     * @returns {Number} 計算結果
     */
    $_orderUtil_calculateCurrentQty (qty) {
      return math.add([
        qty.ordered,
        -qty.canceled,
        -qty.inshipCanceled,
        -qty.transfer,
        -qty.receiveFixed,
        qty.exOut,
        qty.exOutExported,
        qty.exOutFixed,
        -qty.exIn,
        -qty.exInFixed])
    },
    /**
     * 数量移動
     * @param {*} targetQty 更新対象
     * @param {*} movementQty 移動数量(移動元)
     *  - 処理待ちから未引当に2点移動する場合、{ pending: 2 } が入る
     * @param {Array} srcPaths 移動元数量のkey
     * @param {String} destPath 移動先数量のkey
     * @returns {Number} 移動先に移動した数量
     */
    $_orderUtil_moveQty (targetQty, movementQty, srcPaths, destPath) {

      let movementAmount = 0

      // 移動元パス配列を展開
      _.forEach(srcPaths, srcPath => {
        // 移動数量を取得
        movementAmount = math.add([movementAmount, movementQty[srcPath]])
        // 移動元の数量を更新
        targetQty[srcPath] = math.subtract([targetQty[srcPath], movementQty[srcPath]])
      })

      // 移動先の数量を更新
      targetQty[destPath] = math.add([targetQty[destPath], movementAmount])

      return movementAmount
    },
    /**
     * 商品明細が編集可能か判定する
     * @param {*} targetItem 判定対象
     * @param {*} isOrderItem targetItem が商品情報の場合、true
     * @param {*} mode 注文明細画面モード
     * @param {*} orderDetail 注文明細
     */
    $_orderUtil_canEditOrderItem (targetItem, isOrderItem, mode, orderDetail) {
      if ([define.ORDER_MODE.NORMAL, define.ORDER_MODE.SHIPMENT, define.ORDER_MODE.CAPTURE, define.ORDER_MODE.CHANGE_PAYMENT].includes(mode)) {
        // 通常、配送先登録、手動決済、支払方法変更モードは編集不可
        return false
      } else if (mode === define.ORDER_MODE.RECEIVED) {
        // 返品登録モードの場合、商品情報は編集不可
        return !isOrderItem
      } else {
        // 通常、返品登録、配送先登録、手動決済モード以外

        // 売上計上済みの場合
        if ((targetItem.salesItems || []).some((salesItem) => salesItem.salesDatetime != null)) return false
        // 数量が 0 の場合
        if (this.$_orderUtil_current(targetItem.qty) === 0) return false
        // 指図前キャンセル、出荷前キャンセル が 1 以上の場合
        if (this.$_orderUtil_canceled(targetItem.qty) > 0 || this.$_orderUtil_inshipCanceled(targetItem.qty) > 0) return false

        // 指図、出荷、交換指図、交換出荷 が 1 以上の場合
        if (this.$_orderUtil_exported(targetItem.qty) > 0 || this.$_orderUtil_shipped(targetItem.qty) > 0 ||
          this.$_orderUtil_exOutExported(targetItem.qty) > 0 || this.$_orderUtil_exOutShipped(targetItem.qty) > 0) return false

        return true

      }
    },

    /**
     * 商品明細の属性情報をセットする
     * @param {*} rowType 行タイプ (通常、バンドル構成品)
     * @param {*} model 属性情報をセットする対象
     * @param {*} skuData SKUマスタデータ
     */
    $_orderUtil_setOrderItemAttributes (rowType, model, skuData) {

      const attRegion = rowType === 'component' ? 'order_bundle_item_attr' : 'order_item_attr'
      const attrConfig = this.getServiceSiteConfig(null, 'order_detail', attRegion)

      model.attributes = [] // 属性情報をクリア

      for (const k of Object.keys(attrConfig || [])) {
        // 属性設定の 値1 が空ではない場合、商品データの属性情報を取得する
        if (attrConfig[k][this.siteCode].v[0] !== '') {
          const p = attrConfig[k][this.siteCode].v[0]
          const v = skuData.attributes.find(v => v.attrId === p)
          // 商品データの属性を取得できた場合、属性情報を追加する
          if ((v || '') !== '' && v.attrValue !== '') {
            model.attributes.push({
              attrId: k,
              attrValue: v.attrValue
            })
          }
        }
      }
    },

    /**
     * 支払ステータスのコード値を返却する
     * 支払方法＝コンビニ払いかつ支払処理.プロセスコード＝取消かつ金額＝0の場合、
     * 未入金（支払なし）と判断して"2（支払取消）"を返却する。
     * 上記以外の場合、引数の支払完了フラグを返却する。
     * @param {*} payment 注文支払データ
     * @param {*} isPaid 支払完了フラグ
     * @param {*} amount 金額
     * @return {*} 支払ステータスコード値
     */
    $_orderUtil_orderPayment_isPaid (payment, isPaid, amount) {
      return (payment.paymentMethod.code === '3' &&
        payment.paymentSets.some(val => val.processCode === define.PAYMENT_SET_PROCESS.CANCEL) &&
        Number(amount) === 0) ? define.PAYMENT_STATUS.CANCEL : isPaid
    }
  }
}
